import React from "react";
import {langService} from "../jwt/_services";

export const langProvider = {
    getOptions,
    getItem,
    getTranslatableLanguages
};

async function getOptions( dataRequest = {item: {}}){
    try {
        const listItems = await langService.search(0, 1000, dataRequest);

        return listItems?.data.map(({ id, name }) => ({
                id: id,
                value: name,
                label: <div><label>{name}</label></div>}
        ));

    } catch (error) {
       console.log(error.message)
    }

    return []
}

async function getItem(id){
    try {
        const item = await langService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}

async function getTranslatableLanguages(){
    try {
        const dataRequest = {
            item : {
                translateBase : false
            }
        }
        const listItems = await langService.search(0, 1000, dataRequest)

        return listItems.data.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
        console.log('Failed to load the translatable languages\n',error)
    }

    return []
}